import { Fragment, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { useEffect } from 'react';
import { noop } from 'shell/utils/noop';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Detail, { GroupForm } from 'system/components/groups/form';
import { Group } from 'shell/models/group';
import { FunctionalityVM } from 'system/view-models/functionality';
import { CommonGroupCrumbs } from '../constants';

const GroupDetailPage = (): React.ReactElement => {
  const params = useParams();
  const {
    data,
    loading,
    error,
    get: getGroup,
  } = useHttpFetch<HttpResponse<Group>>(`${__MANAGEMENT_API_URL__}/gruppi/${params.id}`);

  const navigate = useNavigate();

  const groupInitialValues: GroupForm = useMemo(() => {
    const group = data?.payload;
    if (!group || !!error) {
      return {
        code: '',
        name: '',
        lastUpdate: '',
        functionality: [],
      };
    }
    return {
      name: group.nome,
      code: group.key?.codice.toString() || '',
      lastUpdate: group.note,
      functionality: group.funzioni?.map((funzione) => ({
        id: funzione.key.codice.toString(),
        description: funzione.nome,
      })) as Array<FunctionalityVM>,
    };
  }, [data, error]);

  useEffect(() => {
    getGroup();
  }, [params.id]);

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonGroupCrumbs, { name: 'Dettaglio Gruppo' }]} />
      {loading || !data || error ? null : (
        <Detail
          title="Dettaglio Gruppo"
          onOk={noop}
          initialValues={groupInitialValues}
          onCancel={() => {
            navigate('/sistema/gruppi');
          }}
          disabled
        />
      )}
    </Fragment>
  );
};

GroupDetailPage.displayName = 'Group Detail page component';

export default GroupDetailPage;
